// // // import './App.css';
// // import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// // import Homepage from '../src/Homepage/Homepage';
// // import Dashboard from '../src/Components/Dashboard';
// // import LandAcquisitionProjects from '../src/Homepage/land-acquisition';
// // import About from '../src/Homepage/About';
// // import ProjectCard from '../src/Homepage/ProjectCard';
// // import CompensationPage from '../src/Homepage/CompensationPage';
// // import { LanguageProvider } from './StoreContext/LanguageContext';



// // function App() {
// //   return (
// //     <LanguageProvider>
// //     <Router>
// //       <Routes>
// //         <Route path="/" element={<Homepage />} />
// //         <Route path="/Dashboard" element={<Dashboard />} />
// //         <Route path="/AboutBuldhanaPage" element={< About/>} />
// //         <Route path="/LandAcquisitionProjects" element={< LandAcquisitionProjects/>} />
// //         <Route path="/ProjectCard" element={<ProjectCard />} />
// //         <Route path="/CompensationPage" element={<CompensationPage/>} />
// //       </Routes>
// //     </Router>
// //     </LanguageProvider>
// //   );
// // }



// // export default App;


// // import './App.css';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import { useEffect } from 'react';
// import { ProjectProvider } from '../src/Components/ProjectContext'; // Adjust path as needed
// import Homepage from '../src/Homepage/Homepage';
// import Dashboard from '../src/Components/Dashboard';
// import LandAcquisitionProjects from '../src/Homepage/land-acquisition';
// import About from '../src/Homepage/About';
// import ProjectCard from '../src/Homepage/ProjectCard';
// import CompensationPage from '../src/Homepage/CompensationPage';
// import { LanguageProvider } from './StoreContext/LanguageContext';
// import GeneralObjection from './Pages/GeneralObjection';

// // Wrap each component to set overflow
// function HomeWrapper() {
//   useEffect(() => {
//     document.body.style.overflow = 'auto';
//     return () => {
//       document.body.style.overflow = 'hidden';
//     };
//   }, []);
//   return <Homepage />;
// }

// function DashboardWrapper() {
//   useEffect(() => {
//     document.body.style.overflow = 'hidden';
//   }, []);
//   return <Dashboard />;
// }
// function GeneralObjectionWrapper() {
//    useEffect(() => {
//     document.body.style.overflow = 'auto';
//     return () => {
//       document.body.style.overflow = 'hidden';
//     };
//   }, []);
//   return <GeneralObjection />;
// }

// function AboutWrapper() {
//   useEffect(() => {
//     document.body.style.overflow = 'auto';
//     return () => {
//       document.body.style.overflow = 'hidden';
//     };
//   }, []);
//   return <About />;
// }

// function LandAcquisitionWrapper() {
//   useEffect(() => {
//     document.body.style.overflow = 'auto';
//     return () => {
//       document.body.style.overflow = 'hidden';
//     };
//   }, []);
//   return <LandAcquisitionProjects />;
// }

// function ProjectCardWrapper() {
//   useEffect(() => {
//     document.body.style.overflow = 'auto';
//     return () => {
//       document.body.style.overflow = 'hidden';
//     };
//   }, []);
//   return <ProjectCard />;
// }

// function CompensationWrapper() {
//   useEffect(() => {
//     document.body.style.overflow = 'auto';
//     return () => {
//       document.body.style.overflow = 'hidden';
//     };
//   }, []);
//   return <CompensationPage />;
// }

// function App() {
//   return (
//     <LanguageProvider>
//       <ProjectProvider>
//       <Router>
//         <Routes>
//           <Route path="/" element={<HomeWrapper />} />
//           <Route path="/Dashboard" element={<DashboardWrapper />} />
//           <Route path="/AboutBuldhanaPage" element={<AboutWrapper />} />
//           <Route path="/LandAcquisitionProjects" element={<LandAcquisitionWrapper />} />
//           <Route path="/ProjectCard" element={<ProjectCardWrapper />} />
//           <Route path="/CompensationPage" element={<CompensationWrapper />} />
//           <Route path="/GeneralObjection" element={<GeneralObjectionWrapper/>}/>
//         </Routes>
//       </Router>
//       </ProjectProvider>
//     </LanguageProvider>
//   );
// }

// export default App;
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect } from 'react';
import { ProjectProvider } from '../src/Components/ProjectContext';
import Homepage from '../src/Homepage/Homepage';
import Dashboard from '../src/Components/Dashboard';
import LandAcquisitionProjects from '../src/Homepage/land-acquisition';
import About from '../src/Homepage/About';
import PublicationSection from '../src/Homepage/PublicationSection'
import ProjectCard from '../src/Homepage/ProjectCard';
import CompensationPage from '../src/Homepage/CompensationPage';
import { LanguageProvider } from './StoreContext/LanguageContext';
import GeneralObjection from './Pages/GeneralObjection';
import PrivateObjection from './Pages/PrivateObjection';
import { ToastContainer } from 'react-toastify';
// import Chatbot from "../src/ChatBoard/Chatbot";
import { Toaster } from 'react-hot-toast';
import ViewDocumentPublic from './Homepage/ViewDocumentPublic';


// Utility function to clear all localStorage
export const clearAllLocalStorage = () => {
  localStorage.clear();
  sessionStorage.clear();
};

// Utility function to clear specific localStorage keys
export const clearSpecificLocalStorage = (keys) => {
  keys.forEach(key => {
    localStorage.removeItem(key);
  });
};

// Comprehensive logout function
export const performCompleteLogout = async (apiService = null) => {
  try {
    // Call API logout if service is provided
    if (apiService && typeof apiService.logout === 'function') {
      await apiService.logout();
    }

    // Get all localStorage keys before clearing
    const allKeys = Object.keys(localStorage);

    // Clear ALL localStorage data
    localStorage.clear();

    // Clear sessionStorage as well
    sessionStorage.clear();

    // Double-check specific keys that might persist
    const criticalKeys = [
      'userData',
      'authToken',
      'userRole',
      'user_role_name',
      'refreshToken',
      'selectedProject',
      'currentProjectData',
      'projectData',
      'dashboardData',
      'languagePreference',
      'sidebarState'
    ];

    // Force remove each critical key individually
    criticalKeys.forEach(key => {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    });

    // Verify clearing worked
    const remainingKeys = Object.keys(localStorage);
    if (remainingKeys.length > 0) {
      console.warn('Some localStorage keys still remain:', remainingKeys);
      // Force clear any remaining keys
      remainingKeys.forEach(key => localStorage.removeItem(key));
    }

    return true;

  } catch (error) {
    console.error('Logout error:', error);

    // Even if API fails, force clear everything locally
    localStorage.clear();
    sessionStorage.clear();

    const criticalKeys = [
      'userData', 'authToken', 'userRole', 'user_role_name',
      'refreshToken', 'selectedProject', 'currentProjectData'
    ];

    criticalKeys.forEach(key => {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    });

    return false;
  }
};

// Wrap each component to set overflow
function HomeWrapper() {
  useEffect(() => {
    document.body.style.overflow = 'auto';
    return () => {
      document.body.style.overflow = 'hidden';
    };
  }, []);
  return <Homepage />;
}

function DashboardWrapper() {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
  }, []);
  return <Dashboard />;
}

function GeneralObjectionWrapper() {
  useEffect(() => {
    document.body.style.overflow = 'auto';
    return () => {
      document.body.style.overflow = 'hidden';
    };
  }, []);
  return <GeneralObjection />;
}

function PrivateObjectionWrapper() {
  useEffect(() => {
    document.body.style.overflow = 'auto';
    return () => {
      document.body.style.overflow = 'hidden';
    };
  }, []);
  return <PrivateObjection />;
}

function AboutWrapper() {
  useEffect(() => {
    document.body.style.overflow = 'auto';
    return () => {
      document.body.style.overflow = 'hidden';
    };
  }, []);
  return <About />;
}

function PublicationSectionWrapper() {
  useEffect(() => {
    document.body.style.overflow = 'auto';
    return () => {
      document.body.style.overflow = 'hidden';
    };
  }, []);
  return <PublicationSection />;
}

function LandAcquisitionWrapper() {
  useEffect(() => {
    document.body.style.overflow = 'auto';
    return () => {
      document.body.style.overflow = 'hidden';
    };
  }, []);
  return <LandAcquisitionProjects />;
}

function ProjectCardWrapper() {
  useEffect(() => {
    document.body.style.overflow = 'auto';
    return () => {
      document.body.style.overflow = 'hidden';
    };
  }, []);
  return <ProjectCard />;
}

function CompensationWrapper() {
  useEffect(() => {
    document.body.style.overflow = 'auto';
    return () => {
      document.body.style.overflow = 'hidden';
    };
  }, []);
  return <CompensationPage />;
}

function App() {
  // Optional: Clear localStorage on app initialization (new user login)
  useEffect(() => {
    // Uncomment the line below if you want to clear localStorage on every app load
    // clearAllLocalStorage();
  }, []);

  return (
    <LanguageProvider>
      <ProjectProvider>
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 25000,
            style: { marginTop: '70px' }
          }}
        />
        <Router>
          <Routes>
            <Route path="/" element={<HomeWrapper />} />
            <Route path="/Dashboard" element={<DashboardWrapper />} />
            <Route path="/AboutBuldhanaPage" element={<AboutWrapper />} />
            <Route path="/OpenDashboard" element={<PublicationSectionWrapper />} />
            <Route path="/LandAcquisitionProjects" element={<LandAcquisitionWrapper />} />
            <Route path="/ProjectCard" element={<ProjectCardWrapper />} />
            <Route path="/CompensationPage" element={<CompensationWrapper />} />
            <Route path="/GeneralObjection" element={<GeneralObjectionWrapper />} />
            <Route path="/PrivateObjection" element={<PrivateObjectionWrapper />} />
            <Route path="/ViewDocumentPublic" element={<ViewDocumentPublic />} />
          </Routes>
        </Router>
        {/* <Chatbot /> */}
        <ToastContainer position="top-right" autoClose={3000} />
      </ProjectProvider>
    </LanguageProvider>

  );
}

export default App;